import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import SelectionView from '../../selection/Selection';
import { BET_BUTTON_CLASS_NAME } from './constants';
import './styles/bet-button.scss';

const propTypes = {
    options: PropTypes.object.isRequired,
    showSelectionLabels: PropTypes.bool,
    gtmAttribute: PropTypes.string,
    isScorecast: PropTypes.bool,
    doTranslateLabel: PropTypes.bool,
};

const defaultProps = { options: { betable: false } };

/**
 * React wrapper for Selection component
 * @return {React} React component.
 */
class BetButton extends React.Component {

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();

        this.updateSuspendedFlag();
        this.selectionEl = null;
    }

    static defaultProps = {
        doTranslateLabel: true,
    };

    updateSuspendedFlag() {
        this.props.options.suspended = !this.props.options.betable;
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
    }

    componentDidUpdate() {
        this.updateSuspendedFlag();
        this.selectionEl.update(this.props.options);
    }

    componentDidMount() {
        const selection = new SelectionView({
            initialState: this.props.options,
            showLabel: this.props.showSelectionLabels,
            label: this.props.options.label,
            gtmAttribute: this.props.gtmAttribute,
            isScorecast: this.props.isScorecast,
            doTranslateLabel: this.props.doTranslateLabel,
        });

        this.containerRef.current.appendChild(selection.el);
        this.selectionEl = selection;
    }

    render() {
        return (
            <div
                ref={this.containerRef}
                className={BET_BUTTON_CLASS_NAME}
            ></div>
        );
    }
}

BetButton.propTypes = propTypes;
BetButton.defaultProps = defaultProps;

export default BetButton;
